import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import { connect } from 'react-redux';
import { change } from 'redux-form';

import Row from 'react-bootstrap/lib/Row';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import Col from 'react-bootstrap/lib/Col';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import renderTooltip from '../../../components/siteadmin/SiteSettingsForm/toolTipHelper.js';
import CurrencyConverter from '../../CurrencyConverter';
import { convert, getFixedValue } from '../../../helpers/currencyConvertion';
import messages from '../../../locale/messages';
import { getServiceFeeValue } from '../../../helpers/getServiceFeeValue.js';

import s from './Calendar.css';
class BillDetails extends Component {
    static propTypes = {
        basePrice: PropTypes.number.isRequired,
        cleaningPrice: PropTypes.number,
        tax: PropTypes.number,
        currency: PropTypes.string.isRequired,
        monthlyDiscount: PropTypes.number,
        weeklyDiscount: PropTypes.number,
        startDate: PropTypes.object.isRequired,
        endDate: PropTypes.object.isRequired,
        serviceFees: PropTypes.shape({
            guest: PropTypes.shape({
                type: PropTypes.string.isRequired,
                value: PropTypes.number.isRequired,
                currency: PropTypes.string.isRequired
            }).isRequired
        }).isRequired,
        base: PropTypes.string.isRequired,
        rates: PropTypes.object.isRequired,
        formatMessage: PropTypes.any,
        specialPricing: PropTypes.array,
    };

    static defaultProps = {
        basePrice: 0, cleaningPrice: 0, tax: 0, monthlyDiscount: 0, weeklyDiscount: 0,
        startDate: null, endDate: null, specialPricing: [],
    }

    render() {
        const { tax, currency, endDate } = this.props;
        const { serviceFees, base, rates, specialPricing, change, toCurrency } = this.props;
        const { formatMessage } = this.props.intl;
        let { startDate, basePrice, cleaningPrice, monthlyDiscount, weeklyDiscount } = this.props;

        let taxes = 0, totalWithoutTax = 0, currentDay, bookingSpecialPricing = [], isSpecialPriceAssigned = false, totalWithoutServiceFee = 0, result;
        let priceForDays = 0, isAverage = 0, isDayTotal = 0, momentStartDate, momentEndDate, dayDifference, discount, discountType, total, convertTotalCurrency = currency;

        if (startDate && endDate) {
            startDate = moment(startDate).format('YYYY-MM-DD');
            momentStartDate = moment(startDate);
            momentEndDate = moment(endDate);
            dayDifference = momentEndDate.diff(momentStartDate, 'days');
            cleaningPrice = getFixedValue(cleaningPrice);
            basePrice = getFixedValue(basePrice);
            monthlyDiscount = getFixedValue(monthlyDiscount);
            weeklyDiscount = getFixedValue(weeklyDiscount);


            if (dayDifference > 0) {
                let stayedNights = [];
                // Find stayed nights
                for (let i = 0; i < dayDifference; i++) {
                    let currentDate = moment(startDate).add(i, 'day');
                    stayedNights.push(currentDate);
                }

                if (stayedNights?.length > 0) {
                    stayedNights.map((item, key) => {
                        let isSpecialPricing;
                        if (item) {
                            let pricingRow, currentPrice;
                            currentDay = (moment(item).format('dddd').toLowerCase());
                            isSpecialPricing = specialPricing?.length > 0 && specialPricing?.find(o => moment(item).format('MM/DD/YYYY') == moment(o.blockedDates).format('MM/DD/YYYY'));
                            if (isSpecialPricing?.isSpecialPrice && (isSpecialPricing?.dayStatus == 'secondHalf' || isSpecialPricing?.dayStatus == 'full')) {
                                isSpecialPriceAssigned = true;
                                currentPrice = Number(isSpecialPricing?.isSpecialPrice);
                            } else {
                                currentPrice = Number(basePrice);
                            }
                            currentPrice = getFixedValue(currentPrice);
                            // Price object
                            pricingRow = {
                                blockedDates: item,
                                isSpecialPrice: currentPrice,
                            };
                            bookingSpecialPricing.push(pricingRow);
                        }
                    });
                }
            }

            priceForDays = bookingSpecialPricing.reduce(
                (total, item) => total + Number(item.isSpecialPrice), 0
            );
            priceForDays = getFixedValue(priceForDays);
            discount = 0;
            discountType = null;
            total = 0;
        }

        isAverage = Number(priceForDays) / Number(dayDifference);
        isAverage = getFixedValue(isAverage);
        isDayTotal = isAverage * dayDifference;
        isDayTotal = getFixedValue(isDayTotal);
        priceForDays = isDayTotal;


        if (dayDifference >= 7) {
            if (monthlyDiscount > 0 && dayDifference >= 28) {
                discount = (Number(priceForDays) * Number(monthlyDiscount)) / 100;
                discountType = monthlyDiscount + "% " + formatMessage(messages.monthlyDiscount);
            } else {
                discount = (Number(priceForDays) * Number(weeklyDiscount)) / 100;
                discountType = weeklyDiscount + "% " + formatMessage(messages.weeklyDiscount);
            }
            discount = getFixedValue(discount);
        }
        totalWithoutServiceFee = (isDayTotal + cleaningPrice) - discount;
        totalWithoutTax = isDayTotal - discount;

        if (serviceFees) {
            result = getServiceFeeValue({ serviceFees, totalWithoutServiceFee, base, rates, currency });
        }

        change("BookingForm", 'isHostServiceEligible', result?.hostServiceFee > priceForDays ? true : false);

        if (tax) taxes = totalWithoutTax * (Number(getFixedValue(tax)) / 100);
        taxes = getFixedValue(taxes);
        total = (priceForDays + result?.guestServiceFee + cleaningPrice + taxes) - discount;

        if (currency != toCurrency) {
            let priceForDaysConvert, serviceFeeConvert, cleaningPriceConvert, taxesConvert, discountConvert;
            priceForDaysConvert = getFixedValue(convert(base, rates, priceForDays, currency, toCurrency));
            serviceFeeConvert = getFixedValue(convert(base, rates, result?.guestServiceFee, currency, toCurrency));
            cleaningPriceConvert = getFixedValue(convert(base, rates, cleaningPrice, currency, toCurrency));
            taxesConvert = getFixedValue(convert(base, rates, taxes, currency, toCurrency));
            discountConvert = getFixedValue(convert(base, rates, discount, currency, toCurrency));
            total = (priceForDaysConvert + serviceFeeConvert + cleaningPriceConvert + taxesConvert) - discountConvert;
            convertTotalCurrency = toCurrency;
        }

        if (isAverage) {
            change("BookingForm", 'averageBasePrice', isAverage);
        }

        return (
            <FormGroup className={s.noMargin}>
                <Row>
                    <Col xs={12} sm={12} md={12} lg={12} className={'viewListingCalender'}>
                        <div className={cx('paymentDetailsFlex', s.billdetail)}>
                            <div className={cx(s.noBorder, 'paymentDetailsFlexLeft')}>
                                {
                                    isSpecialPriceAssigned &&
                                    <div className='tooltipFlex'>
                                        <>{renderTooltip(formatMessage(messages.averagePricePerNight), 'commonTooltipIcon')}</>
                                        <div className={cx(s.specialPriceText, 'directionLtr')}>
                                            <CurrencyConverter
                                                amount={isAverage}
                                                from={currency}
                                            />
                                            {' x'} {dayDifference} {dayDifference > 1 ? formatMessage(messages.nights) : formatMessage(messages.night)}
                                        </div>
                                    </div>
                                }
                                {
                                    !isSpecialPriceAssigned && <div className={cx(s.specialPriceText, 'directionLtr')}>
                                        <CurrencyConverter
                                            amount={isAverage}
                                            from={currency}
                                        />
                                        {' x'} {dayDifference} {dayDifference > 1 ? formatMessage(messages.nights) : formatMessage(messages.night)}
                                    </div>
                                }
                            </div>
                            <div className={'paymentDetailsFlexRight'}>
                                <CurrencyConverter
                                    amount={isDayTotal}
                                    from={currency}
                                />
                            </div>
                        </div>
                        {
                            discount > 0 &&
                            <div className={cx('paymentDetailsFlex', s.billdetail)}>
                                <div className={'paymentDetailsFlexLeft'}>{discountType}</div>
                                <div className={cx('paymentDetailsFlexRight', s.discountText)}>
                                    <span>- </span>
                                    <span className={cx(s.displayCell, s.priceCss)}>
                                        <CurrencyConverter
                                            amount={discount}
                                            from={currency}
                                        />
                                    </span>
                                </div>
                            </div>
                        }
                        {
                            cleaningPrice > 0 &&
                            <div className={cx('paymentDetailsFlex', s.billdetail)}>
                                <div className={'paymentDetailsFlexLeft'}><FormattedMessage {...messages.cleaningFee} /></div>
                                <div className={cx('paymentDetailsFlexRight')}>
                                    <CurrencyConverter
                                        amount={cleaningPrice}
                                        from={currency}
                                    />
                                </div>
                            </div>
                        }
                        {
                            result?.guestServiceFee > 0 && <div className={cx('paymentDetailsFlex', s.billdetail)}>
                                <div className={'paymentDetailsFlexLeft'}><FormattedMessage {...messages.serviceFee} /></div>
                                <div className={'paymentDetailsFlexRight'}>
                                    <CurrencyConverter
                                        amount={result?.guestServiceFee}
                                        from={currency}
                                    />
                                </div>
                            </div>
                        }
                        {
                            taxes > 0 && <div className={cx('paymentDetailsFlex', s.billdetail)}>
                                <div className={'paymentDetailsFlexLeft'}><FormattedMessage {...messages.tax} /> {`(${tax.toFixed(2)}%)`}</div>
                                <div className={'paymentDetailsFlexRight'}>
                                    <CurrencyConverter
                                        amount={taxes}
                                        from={currency}
                                    />
                                </div>
                            </div>
                        }
                        <div className={cx('paymentDetailsFlex', s.billdetail, s.totalBorderTop)}>
                            <div className={cx(s.totalText, 'paymentDetailsFlexLeft')}><FormattedMessage {...messages.total} /></div>
                            <div className={cx(s.totalText, 'paymentDetailsFlexRight')}>
                                <CurrencyConverter
                                    amount={total}
                                    from={convertTotalCurrency}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
            </FormGroup>
        );
    }
}

const mapState = (state) => ({
    specialPricing: state.viewListing.specialPricing,
    toCurrency: state.currency.to || state.currency.base,
});

const mapDispatch = {
    change
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(BillDetails)));